import {AbstractModalView} from "./AbstractModalView";
import {IModalView} from "./IModalView";
import {DialogService, DynamicDialogRef} from "primeng/dynamicdialog";
import {ModalHeaderConfigModel} from "../models/ModalHeaderConfigModel";
import {IModalController, MK_MODAL_HEADER_CONFIG} from "../controllers/IModalController";

export abstract class AbstractHeaderModalView extends AbstractModalView<IModalController> implements IModalView<IModalController> {

  protected readonly configModel: ModalHeaderConfigModel;

  protected constructor(dialogService: DialogService,
                        dialogRef: DynamicDialogRef) {
    super(dialogService, dialogRef);

    this.configModel = this.getController().getModel(MK_MODAL_HEADER_CONFIG);
  }
}
